import { makeStyles } from '@material-ui/core'
import { css } from 'styled-components'
import { content } from '~/themes/colors'

export const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',

		'& input': {
			...theme?.typography?.body1,
			color: content.veryDark,
			marginBottom: 8,
		},

		'& input::placeholder': {
			color: content.dark,
			opacity: 1,
			textOverflow: 'ellipsis !important',
		},
	},

	adorment: {
		marginBottom: 9,
	},
	label: {
		color: theme?.palette?.primary?.main,
		marginBottom: 4,
		...theme?.typography?.subtitle2,
	},
}))

export const textFieldStyle = css(({ theme }) => ({
	width: '100%',

	'.MuiFormHelperText-root': {
		...theme.typography.body3,
	},

	'input::placeholder': {
		...theme.typography.body1,
		color: content.dark,
		opacity: 1,
	},
}))

export const labelStyle = css`
	color: ${({ theme }) => theme.palette.primary.main};
	${({ theme }) => theme.typography.subtitle2}
`
export const viewLabelStyle = css`
	.MuiFormLabel-root {
		color: ${({ theme }) => theme.palette.primary.main};
		${({ theme }) => theme.typography.subtitle2}
	}
`

export const endLabelStyle = css`
	color: ${({ theme }) => theme.colors.content.dark};
`
